export default "__VITE_ASSET__af22b8d8__"